module.exports = __webpack_public_path__ + "static/DigirytepodsHover-519da03edb0405c227372247b31aca2f.png";